import React from 'react';
import "./pages.css";
import profileImage from './assets/profile.jpg'; // Import the image file

const About = () => {
  return (
    <div className="about-container">
      <div className="profile-image">
        <img src={profileImage} alt="Salman Estyak" />
      </div>
      <div className="about-content">
        <p className="about-paragraph">
          Hello! I am Salman Estyak, a third year PhD student in the CSE department at The Pennsylvania State University. 
          My current research focuses on Metastable Failures — an emergent class of failure patterns in large distributed systems that lead to catastrophic outages.
          Detecting, localizing, and resolving these failures in systematic manners pose significant challenges. My research supervisor is Dr. Timothy Zhu.
        </p>
      </div>
    </div>
  );
};

export default About;
